import { render, staticRenderFns } from "./QueueLog.vue?vue&type=template&id=5515fc7f&scoped=true&"
import script from "./QueueLog.vue?vue&type=script&lang=js&"
export * from "./QueueLog.vue?vue&type=script&lang=js&"
import style0 from "./QueueLog.vue?vue&type=style&index=0&id=5515fc7f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515fc7f",
  null
  
)

export default component.exports